import SecurityCard from './SecurityCard';

export default SecurityCard;
